/**
 * @generated SignedSource<<b210864cc6ee0c11dbaedf31e069af1e>>
 * @relayHash c4a57fef7d8d852dc46f0baa09967662
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4a23a120b7c31666aa847f1d247731028f15799c1f2d00566bd580ba03446ff0

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateSingleSelectUserPickerFieldInput = {
  id: string;
  operation: JiraSingleSelectUserPickerFieldOperationInput;
};
export type JiraSingleSelectUserPickerFieldOperationInput = {
  accountId?: string | null | undefined;
  id?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type assignToMeMutationKeyboardShortcutMutation$variables = {
  input: JiraUpdateSingleSelectUserPickerFieldInput;
};
export type assignToMeMutationKeyboardShortcutMutation$data = {
  readonly jira: {
    readonly updateSingleSelectUserPickerField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly user: {
          readonly accountId: string;
          readonly accountStatus: AccountStatus;
          readonly id: string;
          readonly name: string;
          readonly picture: AGG$URL;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type assignToMeMutationKeyboardShortcutMutation$rawResponse = {
  readonly jira: {
    readonly updateSingleSelectUserPickerField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly user: {
          readonly __typename: string;
          readonly accountId: string;
          readonly accountStatus: AccountStatus;
          readonly id: string;
          readonly name: string;
          readonly picture: AGG$URL;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type assignToMeMutationKeyboardShortcutMutation = {
  rawResponse: assignToMeMutationKeyboardShortcutMutation$rawResponse;
  response: assignToMeMutationKeyboardShortcutMutation$data;
  variables: assignToMeMutationKeyboardShortcutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "picture"
},
v7 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "assignToMeMutationKeyboardShortcutMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleSelectUserPickerField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleSelectUserPickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assignToMeMutationKeyboardShortcutMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleSelectUserPickerField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleSelectUserPickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4a23a120b7c31666aa847f1d247731028f15799c1f2d00566bd580ba03446ff0",
    "metadata": {},
    "name": "assignToMeMutationKeyboardShortcutMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b873e16247c81e7ea226f4404dd2b35d";

export default node;
